 document.addEventListener("DOMContentLoaded", function () {
    const allowedHandles = ["yo-yo-desk-pro-2", "yo-yo-desk-pro-1"]; // ✅ Add allowed product handles here

    const productHandle = "{{ product.handle }}"; // Shopify's Liquid variable

    if (!allowedHandles.includes(productHandle)) return; // ❌ Exit if not in allowed list

    const firstImageBlock = document.querySelector(".pd-ov-img img");

    if (!firstImageBlock) return;

    // Create wrapper
    const wrapper = document.createElement("div");
    wrapper.className = "pd-video-wrapper";
    wrapper.style.position = "relative";
    wrapper.style.display = "inline-block";
    wrapper.style.cursor = "pointer";

    // Create play button
    const playBtn = document.createElement("div");
    playBtn.className = "yt-btnslpay";
    wrapper.appendChild(playBtn);

    // Insert wrapper before the image
    firstImageBlock.parentNode.insertBefore(wrapper, firstImageBlock);
    wrapper.appendChild(firstImageBlock);

    const videoUrl = "{{ product.metafields.airf.prod_v_url | strip }}";
    const videoTitle = "{{ product.metafields.airf.vid_title | strip }}";

    let videoElement = null;

    wrapper.addEventListener("click", function () {
      if (!videoUrl || videoUrl === '&nbsp;') return;

      // First click: replace image with video
      if (!videoElement) {
        wrapper.innerHTML = `
          <video preload="auto" autoplay controls title="${videoTitle}" style="width:100%">
            <source src="${videoUrl}" type="video/mp4">
            Your browser does not support the video tag.
          </video>`;
        videoElement = wrapper.querySelector("video");
      } else {
        // If playing, pause → resume after 2 seconds
        if (!videoElement.paused) {
          videoElement.pause();
          setTimeout(() => {
            videoElement.play();
          }, 2000);
        } else {
          videoElement.play();
        }
      }
    });
  });